import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { environment as env_const } from '@env/environment';

import { StoreService } from '@common/services/store.service';
import { CommonDialogsService } from '@common/dialogs/common-dialogs.service';

import { Login } from './login';
import { CredentialsService } from './credentials.service';
import { AccessRefreshTokenResponse } from '@common/models/access-refresh-token-model';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'tiwp-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends Login implements OnInit, AfterViewInit {
  public get isOnline(): boolean {
    return navigator.onLine === true;
  }

  public pageData = {
    user: '',
    password: ''
  };
  public returnUrl: string;
  public _hideText = true;

  readonly translationPath = 'login.';

  constructor(
    protected router: Router,
    protected store: StoreService,
    protected commonDialog: CommonDialogsService,
    protected credentialsService: CredentialsService,
    protected translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super(router, store, commonDialog, credentialsService, translate);
  }

  ngOnInit( ) {
    this.returnUrl = this.activatedRoute.snapshot.queryParams[ 'returnUrl' ] || env_const.desktopUrl;
    this.store.clearStoredUser();
  }

  ngAfterViewInit( ) {
    this.commonDialog.hideSpinner( );
  }

  onUsernameChange( newUsername: string ) {
    // this.pageData.user = newUsername ? newUsername.trim().toLowerCase() : '';
  }

  submitLogin(loginForm: NgForm): void {
    if (loginForm.invalid && (loginForm.dirty || loginForm.touched)) {
      return;
    }
    this.login();
  }

  login(): void {
    this.store.clearStoredUser();

    // this.pageData.user = this.pageData.user.trim().toLowerCase();
    const user = this.pageData.user;
    this.credentialsService
      .getToken$(user, this.pageData.password)
      .subscribe({
        next: (tokenResponse) => this.onTokenResponse(user, tokenResponse),
        error: (tokenRequestError) =>
          this.onInvalidLogin(tokenRequestError).subscribe({
            error: (dialogError) => console.error('Login error dialog failed', dialogError),
          }),
      });
  }

  loginMotivateXR() {
    // La URL de redirección debe apuntar a tu nueva ruta de Angular
    const redirectUri = window.location.origin.includes( 'localhost' ) ?
                                  "https://tiwp-int.tecnalia.com/tiwp/rest_api/login_callback"/* + env_const.motivateXrRedirectUrl*/ :
                                  window.location.origin + '/' + env_const.motivateXrRedirectUrl;
    //
    // Codificar la URI para que sea una URL válida
    const encodedRedirectUri = encodeURIComponent(redirectUri);

    // const authUrl = env_const.motivateXrAuthUrl + `?client_id=kayrox&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;
    // const authUrl = `https://identity.gatv.es/realms/MotivateXR/protocol/openid-connect/auth?client_id=kayrox&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;

    // Redireccionar en la misma pestaña
    // window.location.href = authUrl;
    window.location.href = env_const.motivateXrAuthUrl + `?client_id=kayrox&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;
  }

  loginTecnalia() {
    const redirectUri = window.location.origin.includes( 'localhost' ) ?
                                  "https://tiwp-int.tecnalia.com/tiwp/rest_api/login_callback"/* + env_const.tecnaliaRedirectUrl*/ :
                                  window.location.origin + '/' + env_const.tecnaliaRedirectUrl;
    // https://sso.tecnalia.com/realms/TRI/protocol/openid-connect/auth?client_id=tec-kayrox-visual&redirect_uri=https://tiwp-int.tecnalia.com/tiwp/rest_api/login_callback&response_type=code&scope=openid
    // Codificar la URI para que sea una URL válida
    const encodedRedirectUri = encodeURIComponent(redirectUri);

    // const authUrl = env_const.tecnaliaAuthUrl + `?client_id=tec-kayrox-visual&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;
    // const authUrl = `https://sso.tecnalia.com/realms/TRI/protocol/openid-connect/auth?client_id=kayrox&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;

    // Redireccionar en la misma pestaña
    // window.location.href = authUrl;
    window.location.href = env_const.tecnaliaAuthUrl + `?client_id=tec-kayrox-visual&redirect_uri=${encodedRedirectUri}&response_type=code&scope=openid`;
  }

  private onCorrectAdminLogin( user: string, tokenResponse: AccessRefreshTokenResponse ) {
    this.store.updateUserJwtTokenAfterLoginRegistration( user, tokenResponse.access,  tokenResponse.refresh );
    this.router.navigateByUrl('admin');
  }

  protected onTokenResponse( user: string, tokenResponse: AccessRefreshTokenResponse ) {
    if ( tokenResponse.access && tokenResponse.refresh && user === env_const.adminUser ) {
      this.commonDialog.openTranslatedMessageDialog$(this.translationPath + 'greetingAdmin').subscribe({
        next: () => this.onCorrectAdminLogin(user, tokenResponse),
      });
    } else {
      super.onTokenResponse( user, tokenResponse );
    }
  }
}
